import { keysToCamel } from '@/src/utils/mapper/mapperToCamelCase';
import shopImpressionsLoaded from '@/src/utils/tracking/shopImpressionsLoaded';
import { VendorItemDesktop } from '@components/VendorItemDesktop/VendorItemDesktop';
import VendorRow from '@pedidosya/web-fenix/patterns/VendorRow';
import Highlight from '@pedidosya/web-fenix/system/Highlight';
import { getTagDiscount, getTagMarkup, getTagExclusive } from '@utils//utils';
import List from '@pedidosya/web-fenix/system/List';
import { createElement, useRef } from 'react';
import OnVisibleViewPort from '../../OnVisibleInViewport';

const VendorListingContent = ({
  vendors,
  isDesktop,
  totalVendors,
  handleClickVendor,
  redirectToWeb,
  filterSelected,
  origin,
  rankingRequestId,
  landingId,
  landingTitle,
  landingType,
}) => {
  const trackedImpressions = useRef(new Set());

  const handleVisible = (vendor, vendorPosition) => {
    if (!trackedImpressions.current.has(vendor.id)) {
      shopImpressionsLoaded(
        vendor.occasion,
        vendor.id,
        filterSelected,
        vendorPosition,
        vendor.rankType,
        vendor.isNew,
        rankingRequestId,
        landingId,
        landingTitle,
        landingType,
        false,
        vendor.ncrToken,
        null,
        origin,
        vendor.delivery.deliveryFee,
        vendor.delivery.deliveryTime,
        vendor.rating,
      );
      trackedImpressions.current.add(vendor.id);
    }
  };

  if (isDesktop) {
    return keysToCamel(vendors)?.map((vendor, vendorPosition) => (
      <OnVisibleViewPort
        threshold={0.5}
        key={vendor.id}
        onVisible={() => handleVisible(vendor, vendorPosition)}
      >
        <VendorItemDesktop
          vendorName={vendor?.name}
          variant="header-off"
          isNew={vendor?.isNew}
          rating={vendor?.rating}
          occasion={vendor?.occasion}
          isMarkedAsFavorite={false}
          deliveryETAVariant={vendor?.deliveryEtaVariant}
          deliveryFeeVariant={vendor?.deliveryFeeVariant}
          labels={vendor?.labels}
          images={{
            logo: vendor?.logo,
          }}
          delivery={vendor?.delivery}
          status={vendor?.status}
          renderPlusTag={vendor?.labels?.isLoyalty}
          onClick={() => redirectToWeb(vendor?.url)}
          hideDivider={false}
        />
      </OnVisibleViewPort>
    ));
  }

  return (
    <List collapsable={false} collapsed={false}>
      {totalVendors && totalVendors !== 0 && (
        <List.Title
          titleValue={`${totalVendors} ${
            totalVendors === 1 ? 'local' : 'locales'
          }`}
          size="small"
        />
      )}
      {keysToCamel(vendors)?.map((vendor, vendorPosition) => (
        <List.Row key={vendor.id}>
          <OnVisibleViewPort
            threshold={0.5}
            onVisible={() => handleVisible(vendor, vendorPosition)}
          >
            <VendorRow
              variant="header-off"
              title={vendor?.name}
              rate={vendor?.rating}
              labels={vendor?.labels}
              renderFavToggle={false}
              logo={`${vendor?.logo}?width=100}`}
              delivery={vendor?.delivery}
              deliveryETAVariant={vendor?.deliveryEtaVariant}
              deliveryFeeVariant={vendor?.deliveryFeeVariant}
              ocassion={vendor?.occasion}
              renderPlusTag={vendor?.labels?.isLoyalty}
              onClick={(event) =>
                handleClickVendor(vendor, vendorPosition, event)
              }
              rightIntern={vendor?.isNew ? 'tag-s' : 'rating'}
              rightInternLabel={vendor?.isNew ? 'Nuevo' : null}
              status={vendor?.status?.showOverlay ? 'closed' : 'open'}
              stateText={vendor?.status?.title}
            >
              {(vendor?.labels?.discountLabel?.trim() ||
                vendor?.labels?.markupLabel?.trim() ||
                vendor?.isExclusive) &&
                createElement(VendorRow.TagGroup, {
                  view: 'inline',
                  tags: [
                    vendor?.labels?.discountLabel?.trim() &&
                      getTagDiscount(
                        vendor?.labels?.isLoyalty,
                        vendor?.labels?.discountLabel,
                      ),
                    vendor?.labels?.markupLabel?.trim() &&
                      getTagMarkup(vendor?.labels?.markupLabel),
                    vendor?.isExclusive && getTagExclusive(),
                  ].filter(Boolean),
                })}
              {createElement(
                VendorRow.ServiceInfo,
                {
                  showInfoTime: true,
                  deliveryFeePrice: vendor?.delivery?.deliveryFeeWithDiscount,
                  deliveryFeePriceOriginal: vendor?.delivery?.deliveryFee,
                  deliveryTime: vendor?.delivery?.deliveryTime,
                  pickupDistance: vendor?.delivery?.distance,
                  pickupTime: vendor?.delivery?.pickupTime,
                  kind: vendor?.occasion?.toLowerCase(),
                  deliveryFeeVariant: vendor?.deliveryFeeVariant,
                },
                vendor?.deliveryFeeVariant === 'plus-fomo' &&
                  vendor?.labels?.fomoRightValue &&
                  createElement(
                    VendorRow.ServiceInfo.FeeRightContent,
                    null,
                    createElement(VendorRow.ServiceInfo.RightContent, {
                      value: vendor?.labels?.fomoRightValue,
                      text: vendor?.labels?.fomoRightText,
                    }),
                  ),
              )}
              {createElement(
                VendorRow.HighLightGroupBottom,
                {},
                [
                  vendor?.labels?.sponsoringLabel &&
                    createElement(Highlight, {
                      label: vendor.labels.sponsoringLabel,
                    }),
                  vendor?.labels?.conditionLabels?.[0] &&
                    createElement(Highlight, {
                      label: vendor.labels.conditionLabels[0],
                    }),
                ].filter(Boolean),
              )}
            </VendorRow>
          </OnVisibleViewPort>
        </List.Row>
      ))}
    </List>
  );
};

export default VendorListingContent;
